// features/onboarding/api/onboarding.api.js
// Capa de API para el flujo de onboarding.

import { api } from '../../../api/client';

export const onboardingApi = {
  /**
   * Verifica los datos de onboarding
   * @param {object} data
   */
  verify: (data) =>
    api.post('/onboarding/verify', data),

  /**
   * Valida el token de onboarding
   * @param {string} token
   */
  validateToken: (token) =>
    api.get(`/onboarding/validate?token=${encodeURIComponent(token)}`),

  /**
   * Lista elementos de onboarding (BaseService.search)
   */
  getAll: () =>
    api.get('/onboarding'),

  /**
   * Crea un elemento de onboarding (BaseService.create)
   * @param {object} data
   */
  create: (data) =>
    api.post('/onboarding', data),

  /**
   * Actualiza un elemento de onboarding (BaseService.update)
   * @param {string|number} id
   * @param {object} data
   */
  update: (id, data) =>
    api.put(`/onboarding/${id}`, data),

  /**
   * Elimina un elemento de onboarding (BaseService.delete)
   * @param {string|number} id
   */
  remove: (id) =>
    api.delete(`/onboarding/${id}`),
};
